import { render, staticRenderFns } from "./ClosedNotice.vue?vue&type=template&id=2b5fed26&"
import script from "./ClosedNotice.vue?vue&type=script&lang=js&"
export * from "./ClosedNotice.vue?vue&type=script&lang=js&"
import style0 from "./ClosedNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports